<template>
  <img class="flag" :style="{width: size+'px', height: size+'px'}" :src="path"/>
</template>
<script>

export default {
  props: {
    name: String,
    size: {
      type: Number,
      default: 13
    }
  },
  computed: {
    path(){
      return require(`./images/${this.name}_flag.png`)
    }
  }
}
</script>